import LegacyHeader from '@uikit/components/LegacyHeader/LegacyHeader.wrapper';
import NoticeBar from '@uikit/components/NoticeBar/NoticeBar';
import { Fragment } from 'react';

const cmsComponents = {
  header: LegacyHeader,
  'notice-bar-area': Fragment,
  'notice-bar': NoticeBar,
};

export default cmsComponents;
